export default "__VITE_ASSET__D9Nsv8k4__"